import { all } from "redux-saga/effects";

import AppSaga from "./appSaga";
import SignalrSaga from "./signalrSaga";
import HomeSaga from "./homeSaga";
import VirtualSaga from "./virtualSaga";
import SportSaga from "./sportSaga";
import MainTournamentSaga from "./tournamentEventSaga.js";
import ByDayWeekDaysSaga from "./byDayWeekDaysSaga";
import FeedChanges from "./feedChangesSaga";
import SportTypes from "./sportTypesSaga";
import Categories from "./categoriesSaga";
import SportEvents from "./sportEventsSaga";
import ContactUsSaga from "./contactUsSaga";
import RegisterSaga from "./registerSaga";
import membersSaga from "./membersSaga";
import AuthSaga from "./authSaga";
import GeneralSaga from "./generalSaga";
import BetSlipSaga from "./betSlipSaga";
import SearchSaga from "./searchSaga";
import SlotsSaga from "./slotsSaga";
import ModalSaga from "./modalSaga";
import JackpotSaga from "./jackpotSaga";
import DefaultLiveSportSaga from "./defaultLiveSport";
import LuckyNumberSaga from "./luckyNumbersSaga";
import KioskBannerSaga from "./kioskBannerSaga";
import CustomBetSaga from "./customBetSaga";

export default function* rootSaga(getState) {
  yield all([
    SignalrSaga(),
    GeneralSaga(),
    DefaultLiveSportSaga(),
    HomeSaga(),
    VirtualSaga(),
    SportSaga(),
    MainTournamentSaga(),
    FeedChanges(),
    SportTypes(),
    Categories(),
    SportEvents(),
    ContactUsSaga(),
    RegisterSaga(),
    membersSaga(),
    AuthSaga(),
    BetSlipSaga(),
    AppSaga(),
    SearchSaga(),
    SlotsSaga(),
    ModalSaga(),
    JackpotSaga(),
    ByDayWeekDaysSaga(),
    LuckyNumberSaga(),
    KioskBannerSaga(),
    CustomBetSaga()
  ]);
}
